module.exports = __webpack_public_path__ + "img/ventla-invite-icon-active.a90e2e15.svg";